import { isNumber } from 'lodash';

import { ConflictDictionary } from './charts-conflicts';

export const areConflictsEmpty = (map?: ConflictDictionary) => {
  if (!map) {
    return true;
  }

  for (const key in map) {
    if (map[key as keyof typeof map]?.length) {
      return false;
    }
  }

  return true;
};

export const isConflictIn = (mapArea: string[] | undefined): boolean => {
  return isNumber(mapArea?.length) && mapArea.length > 0;
};
